<input [(ngModel)]="searchTerm"
       appInputRestriction="numbersonly"
       name="{{name}}"
       id="{{id}}"
       class="{{nbcClass}}"
       [typeahead]="glAccountObservable$"
       [typeaheadAsync]="true"
       [typeaheadOptionsLimit]="typeaheadOptionLimit"
       [isAnimated]="true"
       [typeaheadWaitMs]="200"
       [typeaheadMinLength]="5"
       (ngModelChange)="EmitModelData()"
       [required]="isRequired"
       placeholder="{{placeHolder}}"
       [disabled]="!isAuthorized || nbcDisabled"
       authenticate-user="nbcAuthenticateUser"
       authenticate-command="nbcAuthenticateCommand"
       authenticate-required="nbcAuthenticateRequired"
       authenticate-disabled="nbcAuthenticateDisabled"
       (typeaheadOnSelect)="onValueSelected($event)">
